import api from './api';
import {RefreshResponse} from '../types/auth';

export const refreshTokens = async (): Promise<RefreshResponse | false> => {
    try {
        const refreshToken = localStorage.getItem('refreshToken');

        if (!refreshToken) {
            console.error('No refreshToken found');
            removeTokens();
            window.location.href = '/login';
            return false;
        }

        const response = await api.post<RefreshResponse>('/api/auth/refresh', {refreshToken: refreshToken});
        const {accessToken: newAccessToken, refreshToken: newRefreshToken, idToken: newIdToken} = response.data;
        const refreshResponse = {
            accessToken: newAccessToken,
            refreshToken: newRefreshToken,
            idToken: newIdToken,
        } as RefreshResponse;

        updateTokens(refreshResponse);

        return refreshResponse;

    } catch (error) {
        console.error('failed to refresh Tokens:', error);
        removeTokens();
        window.location.href = '/login';
        return false;
    }
};

let updateAuthContextState: (token: string) => void;
export const setAuthContextUpdater = (updater: (token: string) => void) => {
    updateAuthContextState = updater;
};
export const updateTokens = (response: RefreshResponse): void => {
    if (response.accessToken) localStorage.setItem('accessToken', response.accessToken);
    if (response.idToken) localStorage.setItem('idToken', response.idToken);
    if (response.refreshToken) localStorage.setItem('refreshToken', response.refreshToken);
    if (updateAuthContextState) updateAuthContextState(response.accessToken);
}

export const removeTokens = (): void => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('idToken');
}